import { ActionButton } from "modules/actionButton";
import { selectRightPanelState, setPanelState } from "modules/rightPanel";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";

export const RightPanelTabButton = ({
  icon,
  text,
}: {
  icon: React.ReactNode;
  text: string;
}): JSX.Element => {
  const { isOpen, tabId } = useSelector(selectRightPanelState);
  const dispatch = useAppDispatch();

  return (
    <ActionButton
      title={text}
      onClick={() => {
        dispatch(
          setPanelState({
            isOpen: !isOpen,
            tabId,
          }),
        );
      }}
      label={text}
      isActive={isOpen}
      icon={icon}
      throttleTime={800}
      darkMode
    />
  );
};
